import App from "../../app";
import {
	AttemptId, ItemId, ProductId, QuizId, Serializer
} from "../../model/datasource";
import { ChartFrontend } from "../frontend/chart";
import {
	ReviewSectionScoreChart, ReviewTotalScoreChart, TestProgressChart
} from "../../lib/chart";
import OverviewScoreChart from "../../lib/chart/overviewscore";
import OverviewSummaryTable from "../../lib/overviewsummary";

export abstract class ChartView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> {
	frontend: ChartFrontend<P, A, Z>;

	constructor(frontend?: ChartFrontend<P, A, Z>) {
		this.frontend = frontend;
	}

	abstract init(app: App<P, A, Z, I>): void;

	abstract getReviewTotalScoreChart(): ReviewTotalScoreChart
	abstract getReviewSectionScoreChart(): ReviewSectionScoreChart
	abstract getOverviewScoreChart<A, Z>(): OverviewScoreChart<A, Z>
	abstract getTestProgressChart(): TestProgressChart
	abstract getOverviewSummaryTable(jQuery: JQueryStatic): OverviewSummaryTable<P>
}

export class NullChartView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends ChartView<P, A, Z, I> {
	init(app: App<P, A, Z, I>): void { }

	getReviewTotalScoreChart(): ReviewTotalScoreChart {
		throw new Error("Method not implemented.");
	}

	getReviewSectionScoreChart(): ReviewSectionScoreChart {
		throw new Error("Method not implemented.");
	}

	getOverviewScoreChart<A, Z>(): OverviewScoreChart<A, Z> {
		throw new Error("Method not implemented.");
	}

	getTestProgressChart(): TestProgressChart {
		throw new Error("Method not implemented.");
	}

	getOverviewSummaryTable(jQuery: JQueryStatic): OverviewSummaryTable<P> {
		throw new Error("Method not implemented.");
	}
}